import { ListBranchModel } from '../types-store';

export const compareModel = (model1: ListBranchModel, model2: ListBranchModel): boolean =>
  model1?.codetable === model2?.codetable &&
  model1?.category === model2?.category &&
  (model1?.includeInactiveCodes ?? false) === (model2?.includeInactiveCodes ?? false) &&
  model1?.activeType === model2?.activeType;
